import type { Ref } from 'vue';

/** `armed` at Enter, `landed` once the listing the interpreted search opened is on screen. */
export type QuickSearchAiLanding = 'armed' | 'landed';

// The listing an interpreted search opened brings in the filters the AI set one by one, so that the visitor sees them
// as the AI's work.
export const useQuickSearchAiLanding = (): Ref<QuickSearchAiLanding | null> =>
    useState<QuickSearchAiLanding | null>('quickSearchAiLanding', () => null);
